export default "__VITE_PUBLIC_ASSET__73c69293__"